import React, { useState } from "react";
import { Card, DataTable, Text } from "@shopify/polaris";
import ConfirmationModal from "../Common/ConfirmationModal";
import { PAGE_SIZE } from "../../constants/common-constants";

const StoreBoxOrderTable = ({
  storeBoxOrders,
  fetchStoreBoxOrders,
  currentPage,
  setCurrentPage,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrder] = useState(null);

  function capitalizeEachWord(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const handleConfirmDelete = async () => {
    setModalOpen(false);
    fetchStoreBoxOrders();
  };

  const rows = storeBoxOrders.map((order) => {
    return [
      order.orderItems
        .map((item) => {
          return `${item.quantity}${getFirstLetterUppercase(item.box.name)}`;
        })
        .join(", "),
      capitalizeEachWord(order.status),
      order.totalQuantity,
      new Date(order.createdAt).toDateString(),
    ];
  });
  function getFirstLetterUppercase(str) {
    if (typeof str !== "string" || str.trim() === "") {
      return null;
    }
    return str.trim().charAt(0).toUpperCase();
  }
  return (
    <Card>
      <DataTable
        hideScrollIndicator
        columnContentTypes={["text", "text", "text", "text", "text", "text"]}
        headings={[
          <Text variant="headingSm">Order Items</Text>,
          <Text variant="headingSm">Status</Text>,
          <Text variant="headingSm">Total Quantity</Text>,
          <Text variant="headingSm">Ordered on</Text>,
        ]}
        rows={rows}
        pagination={{
          hasNext: storeBoxOrders.length >= PAGE_SIZE,
          onNext: () => {
            setCurrentPage(currentPage + 1);
          },
          onPrevious: () => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          },
          hasPrevious: currentPage > 1,
        }}
      />
      {modalOpen && selectedOrder && (
        <ConfirmationModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={handleConfirmDelete}
          title="Confirm Deletion"
          message={`Are you sure you want to delete the order for store "${selectedOrder.store}"? This action cannot be undone.`}
        />
      )}
    </Card>
  );
};

export default StoreBoxOrderTable;
